<template>
  <div>
    <form class="form-inline margin-bottom">
      <query-search v-model="querySearch" />
      <limit-buttons-group
        v-model="perPage"
        :count="queriesFiltered(querySearch).length"
        :limits="[10, 25, 50, 100]"
        @update:value="currentPage = 1"
      />
    </form>
    <div class="margin-bottom">
      <table
        v-if="projectPositionsQueries.length"
        class="table"
      >
        <thead>
          <tr class="active">
            <th>Позиции</th>
            <th :colspan="showFrequency ? '2' : ''">
              <div
                v-if="!gridXs"
                style="float: left"
              >
                На дату старта
              </div>
              <div
                v-if="canScroll(getPeriodDates(sengine).length)"
                :class="{ 'text-muted': !canScrollLeft}"
                style="float: right"
                :style="[canScrollLeft ? { cursor: 'pointer' } : {}]"
                @click="offsetLeft()"
              >
                <i class="glyphicon glyphicon-triangle-left" />
              </div>
            </th>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            >
              {{ date | moment('DD.MM') }}
            </th>
            <th>
              <i
                v-if="canScroll(getPeriodDates(sengine).length)"
                :class="{ 'text-muted': !canScrollRight(getPeriodDates(sengine).length)}"
                class="glyphicon glyphicon-triangle-right"
                :style="[canScrollRight(getPeriodDates(sengine).length) ? { cursor: 'pointer' } : {}]"
                @click="offsetRight(getPeriodDates(sengine).length)"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Изменение средней позиции</td>
            <th :colspan="showFrequency ? '2' : ''">
              <positions-percent-diff
                v-if="!gridXs"
                :value="getAggregateParamStartValue(sengine, 'avg_position_diff')"
              />
            </th>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            >
              <positions-percent-diff
                :value="getAggregateParamPeriodValue(sengine, 'avg_position_diff', date)"
              />
            </th>
          </tr>
          <tr>
            <td>в ТОП-5</td>
            <th :colspan="showFrequency ? '2' : ''">
              <positions-percent-diff
                v-if="!gridXs"
                :value="getAggregateParamStartValue(sengine, 'top5_percent')"
                :dynamic="false"
              />
            </th>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            >
              <positions-percent-diff
                :value="getAggregateParamPeriodValue(sengine, 'top5_percent', date)"
                :dynamic="false"
              />
            </th>
          </tr>
          <tr>
            <td>в ТОП-10</td>
            <th :colspan="showFrequency ? '2' : ''">
              <positions-percent-diff
                v-if="!gridXs"
                :value="getAggregateParamStartValue(sengine, 'top10_percent')"
                :dynamic="false"
              />
            </th>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            >
              <positions-percent-diff
                :value="getAggregateParamPeriodValue(sengine, 'top10_percent', date)"
                :dynamic="false"
              />
            </th>
          </tr>
          <tr>
            <td>в ТОП-50</td>
            <th :colspan="showFrequency ? '2' : ''">
              <positions-percent-diff
                v-if="!gridXs"
                :value="getAggregateParamStartValue(sengine, 'top50_percent')"
                :dynamic="false"
              />
            </th>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            >
              <positions-percent-diff
                :value="getAggregateParamPeriodValue(sengine, 'top50_percent', date)"
                :dynamic="false"
              />
            </th>
          </tr>
        </tbody>
        <thead>
          <tr class="active">
            <th>Запрос</th>
            <th>
              <span v-if="!gridXs">Продвигаемая страница</span>
            </th>
            <th v-if="showFrequency">
              Частотность
            </th>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            />
            <th>
              <span v-if="!gridXs">C момента старта</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="query of queriesFilteredAndPaginated(querySearch, currentPage, perPage)"
            :key="query.id"
          >
            <td>{{ query.txt }}</td>
            <td>
              <a
                v-if="!gridXs"
                :href="query.url"
              >{{ query.url }}</a>
            </td>
            <th v-if="showFrequency">
              <template v-if="!empty(query.frequency)">
                {{ query.frequency }}
              </template>
              <template v-else>
                -
              </template>
            </th>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            >
              {{ getQueryPositionText(query.id, sengine, date) }}
            </th>
            <th>
              <positions-percent-diff
                :value="getQueryPositionDynamicFromStart(query, sengine)"
                after-text=""
              />
            </th>
          </tr>
        </tbody>
      </table>
      <no-data v-else />
    </div>

    <div class="margin-bottom">
      <c-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="queriesFiltered(querySearch).length"
      />
    </div>
  </div>
</template>

<script>
import PositionsPercentDiff from './PositionsPercentDiff'
import QuerySearch from '../QuerySearch'
import LimitButtonsGroup from '../../../../../../../resources/js/components/LimitButtonsGroup'
import CPagination from '../../../../../../../resources/js/components/ui/CPagination'
import { mapGetters, mapState } from 'vuex'
import tableScrollable from '../../../../../../../resources/js/mixins/tableScrollable'
import helper from '../../../../../../../resources/js/mixins/helper'
import NoData from '../../../../../../../resources/js/components/NoData'

const CURRENT_PAGE_DEFAULT = 1

/**
 * Таблица отчета по позициям.
 */
export default {
  name: 'PositionsTable',
  components: {
    PositionsPercentDiff,
    QuerySearch,
    LimitButtonsGroup,
    CPagination,
    NoData
  },
  mixins: [tableScrollable, helper],
  data () {
    return {
      querySearch: '',
      perPage: 10,
      currentPage: CURRENT_PAGE_DEFAULT
    }
  },
  computed: {
    /**
     * Показывать ли частотность.
     *
     * @returns {boolean}
     */
    showFrequency () {
      return this.clientInfo.settings && this.clientInfo.settings.show_frequency
    },
    ...mapState({
      sengine: state => state.seo.positionsFilter.sengine,
      projectPositionsQueries: state => state.seo.project.positions.queries,
      clientInfo: state => state.seo.client.info.client
    }),
    ...mapGetters({
      getPeriodDates: 'seo/project/positions/getPeriodDates',
      getAggregateParamPeriodValue: 'seo/project/positions/getAggregateParamPeriodValue',
      getAggregateParamStartValue: 'seo/project/positions/getAggregateParamStartValue',
      queriesFiltered: 'seo/project/positions/queriesFiltered',
      queriesFilteredAndPaginated: 'seo/project/positions/queriesFilteredAndPaginated',
      getQueryPositionValue: 'seo/project/positions/getQueryPositionValue',
      getLastPeriodDate: 'seo/project/positions/getLastPeriodDate'
    })
  },
  mounted () {
    this.$root.$on('projectPositionsLoaded', () => {
      this.currentPage = CURRENT_PAGE_DEFAULT
      this.resetScrollOffset()
    })
  },
  methods: {
    /**
     * Возвращает текст позиции.
     *
     * @param {number} id
     * @param {string} sengine
     * @param {string} date
     * @returns {string|*}
     */
    getQueryPositionText (id, sengine, date) {
      const position = this.getQueryPositionValue(id, sengine, date)

      if (this.empty(position)) {
        return '-'
      }

      switch (sengine) {
        case this.$getConst('SENGINE_YANDEX'):
          if (position > 200) {
            return '200+'
          }
          break

        case this.$getConst('SENGINE_GOOGLE'):
          if (position > 50) {
            return '50+'
          }
          break
      }

      return position
    },
    /**
     * Возвращает динамику позиции.
     *
     * @param {object} query
     * @param {string} sengine
     * @returns {null|number}
     */
    getQueryPositionDynamicFromStart (query, sengine) {
      const start = query.start_pos[sengine]
      const last = this.getQueryPositionValue(query.id, sengine, this.getLastPeriodDate(sengine))

      if (!this.empty(start) && !this.empty(last)) {
        return start - last
      }

      return null
    }
  }
}
</script>
